import { FrontChat } from "components/FrontChat";
import { ChatSurfaceCoordinatorProvider } from "providers/ChatSurfaceCoordinator";
import { ProductAnnouncementCoordinatorProvider } from "providers/ProductAnnouncementCoordinator";

import { Appcues } from "../../components/Appcues";
import { Layout } from "../../components/Layout";
import { ScoutLaunchAnnouncement } from "./Scout/LaunchAnnouncement/ScoutLaunchAnnouncement";

export function Customer() {
  return (
    <ChatSurfaceCoordinatorProvider>
      <ProductAnnouncementCoordinatorProvider>
        <Appcues />
        <FrontChat />
        <ScoutLaunchAnnouncement />
        <Layout />
      </ProductAnnouncementCoordinatorProvider>
    </ChatSurfaceCoordinatorProvider>
  );
}
